exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.jumbotron {\n    margin: 20px -13px;\n    padding: 2%; \n    background-color:#FFFFFF;   \n    display: block;\n    border:1px #34495e solid;\n    border-radius: 0px;\n    text-align: left;\n    height: 86px;\n    \n}\n.username{\n    float: right;\n    font-weight: bold;\n}\n.glyphicon-chevron-down{\n    color:#d1251f;\n}\n.glyphicon-user{\n    color:#d1251f;\n}\n.glyphicon-log-out{\n    color:#34495e;\n}\na{\n  color:#34495e;    \n}\nli{\n  color:#d1251f;    \n}\n.logo{\n    margin-top: -15px\n}\n\n.title{\n    font-size:30px !important;\n    font-family: 'inherit';\n    font-style: normal;\n    color:#000000;\n    text-align:center;   \n    line-height: 2;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/header/header.component.css
// module id = 1012
// module chunks = 0